import BottomAction from 'components/BottomAction'
import Pageheader from 'components/Pageheader'
import { Helmet } from 'react-helmet';
import { useNavigate } from 'react-router-dom';
import React, { useEffect, useState, useContext, useRef } from 'react';
import useProfileStore from 'services/store/ProfileModule';
import ModalContext from 'contexts/ModalContext';
import { GetAddress } from 'services/Api/Module/address';
import { GetRestaurant, GetRestaurantBranch } from 'services/Api/Module/Restaurant';
import { PostCheckContactNumber, PutUpdateCustomer, SearchCustomer } from 'services/Api/Module/Customer';
import moment from 'moment';
import useTranslations from 'i18n/useTranslations';
import PullToRefresh from 'components/pullToRefresh/PullToRefresh';
import helper from 'services/helper';
import PopupOtp from 'components/profile/PopupOtp';

const ProfileEdit = () => {

    const [refreshing, setRefreshing] = useState(false)
    const { lang, supportedLangs, setLang } = useTranslations(); // สำหรับเปลี่ยนภาษา
    const { t } = useTranslations();
    const timeoutInputRef = useRef(null);

    const navigate = useNavigate();
    const { mAlert } = useContext(ModalContext);
    const [firstName, setFirstName] = useState("");
    const [lastName, setLastName] = useState("");
    const [birthday, setBirthday] = useState();
    const [gender, setGender] = useState();
    const [contactNumber, setContactNumber] = useState();
    const [email, setEmail] = useState();
    const [pdpa, setPdpa] = useState(0);
    const [marketing, setMarketing] = useState(0);
    const [address, setAddress] = useState();

    const [province, setProvince] = useState([]);
    const [allDistrict, setAllDistrict] = useState([]);
    const [district, setDistrict] = useState([]);
    const [allSubDistrict, setAllSubDistrict] = useState([]);
    const [subDistrict, setSubDistrict] = useState([]);
    const [selectedProvince, setSelectedProvince] = useState("");
    const [selectedDistrict, setSelectedDistrict] = useState("");
    const [selectedSubDistrict, setSelectedSubDistrict] = useState("");
    const [postCode, setPostCode] = useState("");
    const lineProfile = useProfileStore();
    const profile = lineProfile?.customerProfile

    const [isFormComplete, setIsFormComplete] = useState(false);
    const [isOpenModal, setIsOpenModal] = useState(false);
    
    const [openPopUpOtp, setOpenPopUpOtp] = useState(false);
    const [errContactNumber, setErrContactNumber] = useState(false);


    const handleToUpdate = () => {
        let payload = {
            firstName: firstName,
            lastName: lastName,
            gender: gender,
            email: email,
            address: address,
            subDistrict: selectedSubDistrict,
            contactNumber: profile.contactNumber,
            contactNumberNew: contactNumber,
            lineImgUrl: lineProfile?.profile?.pictureUrl ? lineProfile.profile.picturUrl : '',
            lineUid: lineProfile.lineUid
        }
        fetchUpdateCustomer(payload);
    }
    const handleBack = () => {
        navigate('/profile');
    }
    const handleNext = () => {
        let payload = {
            firstName: firstName,
            lastName: lastName,
            gender: gender,
            email: email,
            address: address,
            subDistrict: selectedSubDistrict,
            contactNumber: profile.contactNumber,
            contactNumberNew: contactNumber,
            lineImgUrl: lineProfile?.profile?.pictureUrl ? lineProfile.profile.picturUrl : '',
            lineUid: lineProfile.lineUid
        }
        console.log("🚀 ~ handleNext ~ payload:", payload)
        if (profile.contactNumber == contactNumber) {
            fetchUpdateCustomer(payload);
        } else {
            setOpenPopUpOtp(true)
        }
    };
    const fetchUpdateCustomer = async (payload) => {
        try {
            const response = await PutUpdateCustomer({ params: payload })
            const resData = response.data
            if (resData.resultCode == "20000") {
                navigate('/profile');
            }
            else if (resData.resultCode == "40301") {
                setErrContactNumber(true)
                mAlert.info({
                    title: t.SYSTEM.POPUP.notification,
                    subTitle: t.profile.error.contactNumber,
                    content: "",
                    onClose: () => { },
                })
            } else {
                mAlert.info({
                    title: "ไม่พบเบอร์มือถือ",
                    subTitle: "เบอร์มือถือนี้ไม่ตรงกับเบอร์ในระบบ",
                    content: "",
                    onClose: () => { },
                })
            }
        }
        catch (err) {
            console.log('err ', err)
            mAlert.info({
                title: "แจ้งเตือน",
                subTitle: "มีบางอย่างผิดพลาด",
                content: "",
                onClose: () => { },
            })
        }
    }
    const fetchCheckContactNumber = async (payload) => {
        try {
            const response = await PostCheckContactNumber({ data: payload});
            const resData = response?.data;
            if (resData.resultCode == "20000") {
                setErrContactNumber(false)
            } else {
                setErrContactNumber(true)
            }
        } catch (err) {
            setErrContactNumber(false)
            console.log('err ', err);
        }
    };
    const fetchGetAddress = async () => {
        try {
            const response = await GetAddress();
            const resData = response?.data;
            if (resData.resultCode == "20000") {
                setProvince(resData.resultData.province);
                setAllDistrict(resData.resultData.district);
                setAllSubDistrict(resData.resultData.subDistrict);
            } else {
                mAlert.info({
                    title: "ไม่พบเบอร์มือถือ",
                    subTitle: "เบอร์มือถือนี้ไม่ตรงกับเบอร์ในระบบ",
                    content: "",
                    onClose: () => { },
                });
            }
            setRefreshing(false)
        } catch (err) {
            setRefreshing(false)
            console.log('err ', err);
            mAlert.info({
                title: "แจ้งเตือน",
                subTitle: "มีบางอย่างผิดพลาด",
                content: "",
                onClose: () => { },
            });
        }
    };
    useEffect(() => {
        if (firstName && lastName && birthday && contactNumber && email) {
            setIsFormComplete(true);
        } else {
            setIsFormComplete(false);
        }
        console.log(isFormComplete)
    }, [firstName, lastName, birthday, contactNumber, email]);


    useEffect(() => {
        onLoad()
    }, [profile]);

    useEffect(() => {
        if (selectedProvince) {
            setDistrict(allDistrict.filter(district => district.provinceId === selectedProvince));
        }
    }, [selectedProvince, allDistrict]);

    useEffect(() => {
        if (selectedDistrict) {
            setSubDistrict(allSubDistrict.filter(sub => sub.districtId === selectedDistrict));
        }
    }, [selectedDistrict, allSubDistrict]);
    const handleProvinceChange = (e) => {
        const provinceId = e.target.value;
        setSelectedProvince(provinceId);
        setDistrict(allDistrict.filter(district => district.provinceId == provinceId));
        setSelectedDistrict("");
        setSubDistrict([]);
        setSelectedSubDistrict("");
        setPostCode("");
    };

    const handleDistrictChange = (e) => {
        const districtId = e.target.value;
        setSelectedDistrict(districtId);
        setSubDistrict(allSubDistrict.filter(sub => sub.districtId == districtId));
        setSelectedSubDistrict("");
        setPostCode("");
    };

    const handleSubDistrictChange = (e) => {
        const subDistrictId = e.target.value;
        setSelectedSubDistrict(subDistrictId);
        const selectedSub = subDistrict.find(sub => sub.id == subDistrictId);
        setPostCode(selectedSub ? selectedSub.postCode : "");
    };

    const handleGenderChange = (e) => {
        setGender(parseInt(e.target.value, 10));
    };
    const handleEmail = (e) => {
        setEmail(e.target.value);
    };
    const handleAddress = (e) => {
        setAddress(e.target.value);
    };
    const handleRefresh = () => {
        console.log('handleRefresh!!!')
        setRefreshing(true)
        onLoad();
    }
    const onLoad = () => {
        fetchGetAddress();
        if (profile) {
            setSelectedProvince(profile.ipid || "");
            setSelectedSubDistrict(profile.sdid || "");
            setSelectedDistrict(profile.idid || "");
            setPostCode(profile.postCode || "");
            setFirstName(profile.firstName || "");
            setLastName(profile.lastName || "");
            setGender(profile.gender || "");
            setBirthday(profile.birthday || "");
            setContactNumber(profile.contactNumber || "");
            setEmail(profile.email || "");
            setAddress(profile.address || "");
        }
    }
    
    const formatDateWithBuddhistYear = (date, lang) => {
        const momentDate = moment(date);
        let formattedDate;
        if (lang === 'th') {
            formattedDate = momentDate.locale('th').format('DD MMMM');
            const buddhistYear = parseInt(momentDate.format('YYYY')) + 543;
            return `${formattedDate} ${buddhistYear}`;
        } else {
            formattedDate = momentDate.locale('en').format('DD MMMM YYYY');
            return formattedDate;
        }
    };

    const formatPhoneNumber = (phoneNumber) => {
        if (!phoneNumber) return '';
        const cleaned = ('' + phoneNumber).replace(/\D/g, '');
        const match = cleaned.match(/^(\d{3})(\d{3})(\d{4})$/);
        if (match) {
            return `${match[1]}-${match[2]}-${match[3]}`;
        }
        return phoneNumber;
    };

    // กรณี Edit
    const checkFieldDup = async(lineUid = '', contactNumber = '') => {
        if (timeoutInputRef.current) {
            clearTimeout(timeoutInputRef.current);
        }

        timeoutInputRef.current = setTimeout( async () => {
            const payload = { lineUid: lineUid, contactNumber: contactNumber }
            const rowsDup = await fetchCheckContactNumber(payload)

        }, 500)
    }

    if (openPopUpOtp) {
        return (
            <PopupOtp
                mobile={contactNumber}
                onBack={() => {
                    setOpenPopUpOtp(false)
                }} 
                onSave={() => {
                    setOpenPopUpOtp(false)
                    handleToUpdate()
                }}
            />
        )
    }
    

    return (
        <>
            <PullToRefresh
                refreshing={refreshing}
                onRefresh={handleRefresh}
            >
            <Helmet>
                <title>IMPACT Family</title>
                <meta name="title" content="Impact Family" />
                <meta name="description" content="Impact Family" />
                <meta name="keyword" content="" />
                <meta property="og:title" content="Impact Family" />
                <meta property="og:description" content="Impact Family" />
                <meta property="og:image" content="" />
                <meta property="og:url" content="" />
                <meta property="og:type" content="website" />
                <meta property="og:site_name" content="Impact Family" />
            </Helmet>
            <div id="pageProfile-edit">
                <Pageheader pagename={t.profile.profileEdit} onClick={handleBack} />

                <main id="top">
                    <div class="wrapContent">

                        <section id="pProfile">
                            <div class="bProfile">
                                <div class="bDisplay">
                                    <div class="bPic">
                                        <img src={lineProfile?.profile.pictureUrl ? lineProfile.profile.pictureUrl : "assets/img/logo/logo-color.svg"} alt="" />
                                    </div>
                                    <h1>{lang == 'th'? 'คุณ ':''}{profile.firstName} {profile.lastName}</h1>
                                </div>
                            </div>
                        </section>
                        <section id="pEditProfile">
                            <div class="bForm">
                                <div class="bGroup">
                                    <h2>{t.profile.personal}</h2>
                                    <div class="bRow">
                                        <div class="control-group validate">
                                            <div class="inputPlaceholder">
                                                <span>{t.register.firstName}</span>
                                                <input type="text" name="text" placeholder={t.register.firstName} value={firstName} onChange={(e) => setFirstName(e.target.value)} />
                                            </div>
                                            <label for="" class="tError">Text Error Input</label>
                                        </div>
                                    </div>
                                    <div class="bRow">
                                        <div class="control-group validate">
                                            <div class="inputPlaceholder">
                                                <span>{t.register.lastName}</span>
                                                <input type="text" name="text" placeholder={t.register.firstName} value={lastName} onChange={(e) => setLastName(e.target.value)} />
                                            </div>
                                            <label for="" class="tError">Text Error Input</label>
                                        </div>
                                    </div>
                                    <div class="bRow">
                                        <div class="control-group">
                                            <div class="date">
                                                <input placeholder="Date" type="text" class="inputDate" value={formatDateWithBuddhistYear(profile.birthday)} disabled />
                                            </div>
                                            <label for="" class="tError">Text Error Input</label>
                                        </div>
                                    </div>
                                    <div class="bRow">
                                        <div class="control-group">
                                            <div class="tTitle">{t.register.gender}</div>
                                            <div class="gender">
                                                <label className="control control--radio">{t.register.male}
                                                    <input type="radio" name="radio" checked={gender == 0} onChange={handleGenderChange} value="0" />
                                                    <div className="control__indicator"></div>
                                                </label>
                                                <label className="control control--radio">{t.register.female}
                                                    <input type="radio" name="radio" checked={gender == 1} onChange={handleGenderChange} value="1" />
                                                    <div className="control__indicator"></div>
                                                </label>
                                                <label className="control control--radio">{t.register.neutral}
                                                    <input type="radio" name="radio" checked={gender == 2} onChange={handleGenderChange} value="2" />
                                                    <div className="control__indicator"></div>
                                                </label>
                                            </div>
                                            <label for="" class="tError">Text Error Input</label>
                                        </div>
                                    </div>
                                    <div class="bRow">
                                        <div class={`control-group ${errContactNumber ? 'error' : ''} `}>
                                            <input type="text" 
                                                inputMode="numeric" 
                                                name="" 
                                                placeholder={t.register.phone} 
                                                value={contactNumber} 
                                                onInput={helper.FNFORM.handleNumberOnly} 
                                                onChange={(e) => {
                                                    setErrContactNumber(false)
                                                    setContactNumber(e.target.value)
                                                    checkFieldDup(lineProfile.lineUid, e.target.value)
                                                }}
                                                maxLength={10}
                                            />
                                            { errContactNumber && <label for="" class="tError" style={{ display: 'flex', lineHeight: '100%' }}>{t.profile.error.contactNumber}</label>}
                                        </div>
                                    </div>
                                    <div class="bRow">
                                        <div class="control-group validate">
                                            <div class="inputPlaceholder">
                                                <span>{t.register.email}</span>
                                                <input type="text" name="text" placeholder={t.register.email} value={email} onChange={handleEmail} />
                                            </div>
                                            <label for="" class="tError">Text Error Input</label>
                                        </div>
                                    </div>

                                </div>
                                <div class="bGroup">
                                    <h2>{t.register.address}</h2>
                                    <div class="bRow">
                                        <div class="control-group">
                                            <input type="text" name="text" placeholder={t.register.addressInfo} value={address} onChange={handleAddress} />
                                            <label for="" class="tError">Text Error Input</label>
                                        </div>
                                    </div>
                                    <div class="bRow">
                                        <div class="control-group">
                                            <div class="select">
                                                <select value={selectedProvince} onChange={handleProvinceChange}>
                                                    <option>{t.register.province}</option>
                                                    {province?.map((prov, index) => (
                                                        <option key={index} value={prov.id}>{prov.name}</option>
                                                    ))}
                                                </select>
                                            </div>
                                            <label for="" class="tError">Text Error Input</label>
                                        </div>
                                    </div>
                                    <div class="bRow">
                                        <div class="control-group">
                                            <div class="select">
                                                <select value={selectedDistrict} onChange={handleDistrictChange}>
                                                    <option>{t.register.district}</option>
                                                    {district?.map((dist, index) => (
                                                        <option key={index} value={dist.id}>{dist.name}</option>
                                                    ))}
                                                </select>
                                            </div>
                                            <label for="" class="tError">Text Error Input</label>
                                        </div>
                                        <div class="control-group">
                                            <div class="select">
                                                <select value={selectedSubDistrict} onChange={handleSubDistrictChange}>
                                                    <option>{t.register.subDistrict}</option>
                                                    {subDistrict?.map((sub, index) => (
                                                        <option key={index} value={sub.id}>{sub.name}</option>
                                                    ))}
                                                </select>
                                            </div>
                                            <label for="" class="tError">Text Error Input</label>
                                        </div>

                                    </div>
                                    <div class="bRow">
                                        <div class="control-group">
                                            <input type="text" name="text" placeholder={t.register.zipcode} value={postCode} disabled />
                                            <label for="" class="tError">Text Error Input</label>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </section>
                        <BottomAction handleBack={handleBack} handleOk={handleNext} isFormComplete={isFormComplete && !errContactNumber && contactNumber.length === 10} />
                        {/* <!-- Page Button Menu -->
                        <?php include 'inc/inc-bottom-action.php';?> */}

                        {/* <!-- Modal -->
                        <?php include 'inc/inc-modal.php';?> */}

                    </div>
                </main>

            </div>
            </PullToRefresh>
        </>
    )
}

export default ProfileEdit